import * as React from "react";
import { useState, useContext } from "react";
import { useTranslation } from "react-i18next";
import AuthenticationDomain from "domainActions/authentication/AuthenticationDomain";
import { Button } from "components/bootstrap";
import { Spinner } from "components/common";
import ConnectionErrors, { NotificationContainer } from "./ConnectionErrors";
import BackendWizardContext from "./BackendWizardContext";
const _addRequiredRequestPayload = (formValues) => {
  const necessaryAttributes = { ...formValues };
  if (!necessaryAttributes.config.user_search_base) {
    necessaryAttributes.config.user_search_base = "";
  }
  if (!necessaryAttributes.config.user_search_pattern) {
    necessaryAttributes.config.user_search_pattern = "";
  }
  return necessaryAttributes;
};
const ServerConnectionTest = ({ prepareSubmitPayload }) => {
  const { authBackendMeta } = useContext(BackendWizardContext);
  const { t } = useTranslation("authentication");
  const [{ loading, success, message, errors }, setConnectionStatus] = useState({
    loading: false,
    success: false,
    message: void 0,
    errors: void 0
  });
  const _handleConnectionCheck = () => {
    const payload = _addRequiredRequestPayload(prepareSubmitPayload(void 0));
    setConnectionStatus({ loading: true, message: void 0, errors: void 0, success: false });
    AuthenticationDomain.testConnection({ backend_configuration: payload, backend_id: authBackendMeta.backendId }).then((response) => {
      setConnectionStatus({
        loading: false,
        message: response == null ? void 0 : response.message,
        success: response == null ? void 0 : response.success,
        errors: response == null ? void 0 : response.errors
      });
    }).catch((error) => {
      var _a, _b;
      const requestErrors = [error == null ? void 0 : error.message, (_b = (_a = error == null ? void 0 : error.additional) == null ? void 0 : _a.res) == null ? void 0 : _b.text];
      setConnectionStatus({ loading: false, message: void 0, errors: requestErrors, success: false });
    });
  };
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("p", null, t("connection_test.description")), /* @__PURE__ */ React.createElement(Button, { onClick: _handleConnectionCheck, type: "button" }, loading ? /* @__PURE__ */ React.createElement(Spinner, { delay: 0, text: t("connection_test.submit") }) : t("connection_test.submit")), success && /* @__PURE__ */ React.createElement(NotificationContainer, { bsStyle: "success" }, /* @__PURE__ */ React.createElement("b", null, message)), errors && errors.length >= 1 && /* @__PURE__ */ React.createElement(ConnectionErrors, { errors, message }));
};
export default ServerConnectionTest;
